<script setup lang="ts">
const props = withDefaults(defineProps<{ demoEnabled?: boolean }>(), {
  demoEnabled: false,
});

const emit = defineEmits<{
  demoLogin: [role: 'landlord' | 'tenant' | 'accountant'];
}>();
</script>

<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
    <div class="text-center mb-8">
      <h1 class="text-3xl font-display text-gray-900">Property Management</h1>
      <p class="text-gray-600 mt-1">LinBrandon LLC</p>
    </div>

    <template v-if="props.demoEnabled">
      <!-- DEMO SECTION (above Clerk to ensure visibility) -->
      <div class="w-full max-w-md mb-6">
        <div class="bg-white/80 backdrop-blur-md rounded-2xl border border-gray-200 shadow-xl p-6">
          <p class="text-center text-sm text-gray-600 mb-4">Try a demo account</p>
          <div class="space-y-3">
            <button
              data-testid="demo-login-landlord"
              class="btn-press w-full flex items-center justify-center gap-3 px-4 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 font-semibold transition-colors"
              @click="emit('demoLogin', 'landlord')"
            >
              <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              Demo: Landlord (Full Access)
            </button>

            <button
              data-testid="demo-login-tenant"
              class="btn-press w-full flex items-center justify-center gap-3 px-4 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 font-semibold transition-colors"
              @click="emit('demoLogin', 'tenant')"
            >
              <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/>
              </svg>
              Demo: Tenant (View Own Lease)
            </button>

            <button
              data-testid="demo-login-accountant"
              class="btn-press w-full flex items-center justify-center gap-3 px-4 py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 font-semibold transition-colors"
              @click="emit('demoLogin', 'accountant')"
            >
              <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"/>
              </svg>
              Demo: Accountant (Read-Only)
            </button>
          </div>
        </div>
      </div>
      <!-- DIVIDER -->
      <div class="w-full max-w-md">
        <div class="relative my-6">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-300"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-4 bg-gradient-to-br from-blue-50 to-indigo-100 text-gray-400">
              Or sign in with your account
            </span>
          </div>
        </div>
      </div>
    </template>

    <!-- CLERK (now below demo buttons) -->
    <div id="clerk-sign-in" class="w-full max-w-md"></div>
  </div>
</template>
